"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _emptyFunction = _interopRequireDefault(require("react-utils/emptyFunction"));

var _ReferenceResolverType = _interopRequireDefault(require("reference-resolvers/schema/ReferenceResolverType"));

var _PropertyInputEmail = _interopRequireDefault(require("customer-data-properties/input/PropertyInputEmail"));

var _ComponentMethods = require("customer-data-ui-utilities/component/ComponentMethods");

var propTypes = {
  autoFocus: _react.PropTypes.bool,
  onInvalidProperty: _react.PropTypes.func.isRequired,
  propertyIndex: _react.PropTypes.number,
  showError: _react.PropTypes.bool,
  value: _react.PropTypes.string,
  subjectId: _react.PropTypes.string,
  resolver: _ReferenceResolverType.default,
  className: _react.PropTypes.string,
  size: _react.PropTypes.object,
  suppressAlerts: _react.PropTypes.bool
};
var defaultProps = {
  size: {
    xs: 12
  },
  className: 'p-x-0',
  wrapperClassName: 'p-left-0',
  onInvalidProperty: _emptyFunction.default
};
var initialState = {
  hasBlurred: false
};

var PropertyInputEmailWrapper =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(PropertyInputEmailWrapper, _React$Component);

  function PropertyInputEmailWrapper() {
    var _this;

    (0, _classCallCheck2.default)(this, PropertyInputEmailWrapper);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(PropertyInputEmailWrapper).call(this));
    (0, _ComponentMethods.bindHandlers)((0, _assertThisInitialized2.default)(_this));
    _this.state = initialState;
    return _this;
  }

  (0, _createClass2.default)(PropertyInputEmailWrapper, [{
    key: "focus",
    value: function focus() {
      this.refs.input.focus();
    }
  }, {
    key: "handleBlur",
    value: function handleBlur() {
      this.setState({
        hasBlurred: true
      });
    }
  }, {
    key: "handleFocus",
    value: function handleFocus() {
      this.setState({
        hasBlurred: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var blur = this.state.hasBlurred;
      return _react.default.createElement(_PropertyInputEmail.default, (0, _extends2.default)({}, this.props, {
        hasBlurred: blur,
        handleBlur: this.handleBlur,
        handleFocus: this.handleFocus,
        ref: "input"
      }));
    }
  }]);
  return PropertyInputEmailWrapper;
}(_react.default.Component);

PropertyInputEmailWrapper.propTypes = propTypes;
PropertyInputEmailWrapper.defaultProps = defaultProps;
var _default = PropertyInputEmailWrapper;
exports.default = _default;
module.exports = exports.default;